import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../ui/Button";
import { ButtonSize } from "../ComponentsType";
import useAuth from "store/modules/auth/authHook";
import { useTopSelected } from "store/modules/navigates/navigatesHook";

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  width: 100%;
  height: 56px;
  padding: 0;
  background-color: #fff;
  border-bottom: 1px solid var(--border-normal);

  z-index: 1;

  @media screen and (max-width: 767px) {
    height: 45px;
  }
`;

export const SeerviceWrap = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const HeaderLogo = styled.h1`
  display: flex;
  align-items: center;
  width: 91.6px;
  & a {
    display: block;
  }
  & img {
    display: inline-block;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    width: 80px;
  }
`;

const GnbWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 30px;
`;

const HeaderBtnWrap = styled.div<{ isActive: boolean }>`
  display: flex;
  height: 32px;
  border-radius: 8px;

  button {
    color: #444;
    font-weight: 500;
    font-size: 14px;
    ${props => (props.isActive === true ? `background-color: var(--secondary); color: #fff` : "")};
    padding: 6px 15px;
    border-radius: 8px;
  }
`;

function HeaderMenu(props: { menu: string; isActive: boolean }) {
  const { logout } = useAuth();

  const nav = useNavigate();

  return (
    <HeaderBtnWrap isActive={props.isActive}>
      <Button
        btnSize={ButtonSize.MD}
        btnType="ghost"
        text={props.menu === "notice" ? "공지사항" : props.menu === "setting" ? "계정설정" : "로그아웃"}
        onClick={() => {
          props.menu !== "logout" ? nav(`/admin/${props.menu}`) : logout();
        }}
      />
    </HeaderBtnWrap>
  );
}

function Header(): JSX.Element {
  const { name, getToken, role } = useAuth();
  const getTopSelected = useTopSelected();

  const sTop = getTopSelected();

  const menu = ["notice", "setting", "logout"];

  useEffect(() => {
    if (name === "" || name === undefined) {
      getToken();
    }
  }, [role]);

  return (
    <HeaderContainer>
      {/* <GnbWrap isActive={s.router === loc?.pathname}> */}
      <GnbWrap>
        {menu.map(i => {
          return <HeaderMenu key={i} menu={i} isActive={i === sTop} />;
        })}
      </GnbWrap>
    </HeaderContainer>
  );
}

export default React.memo(Header);
